import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { v4 as uuidv4 } from 'uuid';

const cache = new InMemoryCache({
    addTypename: false
});

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_URL,
    credentials: 'include'
});

const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists

    // Generate unique nonce and timestamp for each request
    const nonce = uuidv4();
    const timestamp = Date.now().toString();

    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            'X-Request-Nonce': nonce,
            'X-Request-Timestamp': timestamp
        }
    };
});

export const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache
});
